/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const ShopifyCartURLs = [
    "add",
    "add.js",
  ];

  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`${path}`);
  }

  const dispatchEvent = async (url, detail) => {
    if (!detail) return;
    if (detail.status === 422) {
      let cart = await fetch('/cart.js').then((res) => res.json());
      cart.items.map((item) => {
        let metreage = item.properties.Metres;
        if (metreage && item.quantity != metreage * 2) {
          item.properties.Metres = item.quantity / 2;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: item.properties
          })
        });
        return item;
      });
    }
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);
      if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
      }

      return response;
    };
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  XHROverride();
  fetchOverride();

  let recommendedPatterns = document.querySelector('.recommended-patterns');
  if (recommendedPatterns) {
    let recommendedPatternsSlider = new themeVendor.Flickity(recommendedPatterns, {
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      prevNextButtons: true,
      cellSelector: '.rec-line',
      watchCSS: true,
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

class QuantityPicker extends HTMLElement {
  min = 1;
  increment = 1;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.quantity-picker__button--minus');
    this.quantityPlus = this.querySelector('.quantity-picker__button--plus');
    this.quantityInput = this.querySelector('.quantity-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));

  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    if (newValue < this.min) {
      newValue = this.min;
    } else {
      this.updateQuantity(newValue);
    } 
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  async updateQuantity (newValue) {
    this.quantityInput.value = newValue;
    this.quantityInput.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { value: newValue } }));
  }
}

customElements.define('quantity-picker', QuantityPicker);

class YardPicker extends HTMLElement {
  min = 0.5;
  increment = 0.5;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.yard-picker__button--minus');
    this.quantityPlus = this.querySelector('.yard-picker__button--plus');
    this.quantityInput = this.querySelector('.yard-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));
    this.quantityInput.addEventListener('change', (e) => {
      this.updateQuantity(e.target.value);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    this.updateQuantity(newValue);
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  updateQuantityDisplay (newValue, newQuantity) {
    if (newQuantity == this.dataset.max) {
      this.quantityPlus.setAttribute('disabled', 'true');
    } else {
      this.quantityPlus.removeAttribute('disabled');
    }

    if (newValue == this.min) {
      this.quantityMinus.setAttribute('disabled', 'true');
    } else {
      this.quantityMinus.removeAttribute('disabled');
    }
  }


  async updateQuantity (newValue) {
    let newQuantity = newValue * 2;
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newQuantity > this.dataset.max) {
      newValue = this.dataset.max / 2;
      newQuantity = this.dataset.max;
    } else if (newValue % this.increment !== 0) {
      newValue = Math.round(newValue / this.increment) * this.increment;
    }

    let oldValue = this.quantityInput.value;
    this.quantityInput.value = newValue;


    if (oldValue == newValue) return;


    if (this.type == 'product') {
      this.formSubmit.querySelector('[name="quantity"]').value = newValue * 2;
      this.formSubmit.querySelector('#yard_property').value = newValue;
    } else if (this.type == 'bundle') {
      this.querySelector('.yard-picker__quantity').dataset.quantity = newValue * 2;
      this.querySelector('.yard-picker__quantity').dataset.yards = newValue;
    } else {
      let cartItem = this.closest('.cart__item');
      let cartDrawer = this.closest('.cart-drawer');
      if (!cartDrawer) {
        cartDrawer = document.querySelector('.cart__items__wrapper');
      }
      let cartCheckoutButton = document.querySelector('.cart__checkout.btn');
      cartItem.classList.add('is-loading');
      cartDrawer.classList.add('is-loading');
      cartCheckoutButton.setAttribute('disabled', 'true');
      let itemKey = cartItem.dataset.item;
      let resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue * 2,
          properties: {
            Metres: newValue
          }
        })
      });
      let cart = await resp.json();
      cartItem.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { id: itemKey, quantity: newValue * 2, properties: { Metres: newValue } } }));
      if (cart.status === 422) {
        cartItem.classList.remove('is-loading');
        cartDrawer.classList.remove('is-loading');
        cartCheckoutButton.removeAttribute('disabled');
        this.quantityInput.value = oldValue;
      }
    }
  }  
}

class FullYardPicker extends HTMLElement {
  min = 1;
  increment = 1;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.full-yard-picker__button--minus');
    this.quantityPlus = this.querySelector('.full-yard-picker__button--plus');
    this.quantityInput = this.querySelector('.full-yard-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));
    this.quantityInput.addEventListener('change', (e) => {
      this.updateQuantity(e.target.value);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    this.updateQuantity(newValue);
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  updateQuantityDisplay (newValue, newQuantity) {
    if (newQuantity == this.dataset.max) {
      this.quantityPlus.setAttribute('disabled', 'true');
    } else {
      this.quantityPlus.removeAttribute('disabled');
    }

    if (newValue == this.min) {
      this.quantityMinus.setAttribute('disabled', 'true');
    } else {
      this.quantityMinus.removeAttribute('disabled');
    }
  }

  async updateQuantity (newValue) {
    // Remove the multiplication by 2
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newValue > this.dataset.max) {
      newValue = this.dataset.max;
    } else if (newValue % this.increment !== 0) {
      newValue = Math.round(newValue / this.increment) * this.increment;
    }

    let oldValue = this.quantityInput.value;
    this.quantityInput.value = newValue;

    if (oldValue == newValue) return;

    if (this.type == 'product') {
      // Remove the multiplication by 2 here
      this.formSubmit.querySelector('[name="quantity"]').value = newValue;
      this.formSubmit.querySelector('#yard_property').value = newValue;
    } else if (this.type == 'bundle') {
      // Remove the multiplication by 2 here
      this.querySelector('.full-yard-picker__quantity').dataset.quantity = newValue;
      this.querySelector('.full-yard-picker__quantity').dataset.yards = newValue;
    } else {
      let cartItem = this.closest('.cart__item');
      let cartDrawer = this.closest('.cart-drawer');
      if (!cartDrawer) {
        cartDrawer = document.querySelector('.cart__items__wrapper');
      }
      let cartCheckoutButton = document.querySelector('.cart__checkout.btn');
      cartItem.classList.add('is-loading');
      cartDrawer.classList.add('is-loading');
      cartCheckoutButton.setAttribute('disabled', 'true');
      let itemKey = cartItem.dataset.item;
      let resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue, // Remove the multiplication by 2 here
          properties: {
            Metres: newValue
          }
        })
      });
      let cart = await resp.json();
      cartItem.dispatchEvent(new CustomEvent('theme:cart:update', { 
        bubbles: true, 
        detail: { 
          id: itemKey, 
          quantity: newValue, // Remove the multiplication by 2 here
          properties: { Metres: newValue } 
        } 
      }));
      if (cart.status === 422) {
        cartItem.classList.remove('is-loading');
        cartDrawer.classList.remove('is-loading');
        cartCheckoutButton.removeAttribute('disabled');
        this.quantityInput.value = oldValue;
      }
    }
  }
}

class QuarterYardPicker extends HTMLElement {
  min = 0.25;
  increment = 0.25;

  constructor () {
    super();
    this.quantityMinus = this.querySelector('.quarter-yard-picker__button--minus');
    this.quantityPlus = this.querySelector('.quarter-yard-picker__button--plus');
    this.quantityInput = this.querySelector('.quarter-yard-picker__quantity');
    this.formSubmit = document.querySelector('.product__form');
    this.type = this.dataset.type;

    this.quantityMinus.addEventListener('click', this.decrementQuantity.bind(this));
    this.quantityPlus.addEventListener('click', this.incrementQuantity.bind(this));
    this.quantityInput.addEventListener('change', (e) => {
      this.updateQuantity(e.target.value);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

  }

  decrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) - this.increment;
    this.updateQuantity(newValue);
  }

  incrementQuantity () {
    let newValue = parseFloat(this.quantityInput.value) + this.increment;
    this.updateQuantity(newValue);
  }

  updateQuantityDisplay (newValue, newQuantity) {
    if (newQuantity == this.dataset.max) {
      this.quantityPlus.setAttribute('disabled', 'true');
    } else {
      this.quantityPlus.removeAttribute('disabled');
    }

    if (newValue == this.min) {
      this.quantityMinus.setAttribute('disabled', 'true');
    } else {
      this.quantityMinus.removeAttribute('disabled');
    }
  }


  async updateQuantity (newValue) {
    let newQuantity = newValue * 4;  // Convert quarter yards to units
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newQuantity > this.dataset.max) {
      newValue = this.dataset.max / 4;  // Convert max units back to quarter yards
      newQuantity = this.dataset.max;
    } else if (newValue % this.increment !== 0) {
      newValue = Math.round(newValue / this.increment) * this.increment;
    }
  
    let oldValue = this.quantityInput.value;
    this.quantityInput.value = newValue;
  
    if (oldValue == newValue) return;
  
    if (this.type == 'product') {
      this.formSubmit.querySelector('[name="quantity"]').value = newValue * 4;
      this.formSubmit.querySelector('#yard_property').value = newValue;
    } else if (this.type == 'bundle') {
      this.querySelector('.quarter-yard-picker__quantity').dataset.quantity = newValue * 4;
      this.querySelector('.quarter-yard-picker__quantity').dataset.yards = newValue;
    } else {
      let cartItem = this.closest('.cart__item');
      let cartDrawer = this.closest('.cart-drawer');
      if (!cartDrawer) {
        cartDrawer = document.querySelector('.cart__items__wrapper');
      }
      let cartCheckoutButton = document.querySelector('.cart__checkout.btn');
      cartItem.classList.add('is-loading');
      cartDrawer.classList.add('is-loading');
      cartCheckoutButton.setAttribute('disabled', 'true');
      let itemKey = cartItem.dataset.item;
      let resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: newValue * 4,  // Use quarter yard multiplication
          properties: {
            Metres: newValue
          }
        })
      });
      let cart = await resp.json();
      cartItem.dispatchEvent(new CustomEvent('theme:cart:update', { 
        bubbles: true, 
        detail: { 
          id: itemKey, 
          quantity: newValue * 4,  // Use quarter yard multiplication
          properties: { Metres: newValue } 
        } 
      }));
      if (cart.status === 422) {
        cartItem.classList.remove('is-loading');
        cartDrawer.classList.remove('is-loading');
        cartCheckoutButton.removeAttribute('disabled');
        this.quantityInput.value = oldValue;
      }
    }
  }
}

customElements.define('yard-picker', YardPicker);
customElements.define('full-yard-picker', FullYardPicker);
customElements.define('quarter-yard-picker', QuarterYardPicker);

function validateCartQuantity(item) {
  const metres = item.properties?.Metres;
  if (!metres) return true;

  // Different multipliers based on product type
  const multiplier = item.product_type === 'quarter-yard' ? 4 : 2;
  const expectedQuantity = metres * multiplier;
  
  return item.quantity === expectedQuantity;
}

async function updateCart(item, newQuantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: newQuantity,
        properties: {
          Metres: newQuantity / (item.product_type === 'quarter-yard' ? 4 : 2)
        }
      })
    });
    
    if (!response.ok) {
      console.error('Cart update failed:', response);
      // Revert UI changes
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Cart update error:', error);
    return false;
  }
}